import InitParameters = ym.InitParameters;
import config from '@platform/shared/config';

const ymInitParams: InitParameters = {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
};

export function initMetrika(res?: { userRes: any; orgsRes: any[] } | null) {
    if (!window.ym || !config.metrikaId) return;
    const appendInitParams: InitParameters = {};
    if (res?.userRes) {
        const mainOrg = res.orgsRes.find((org) => org.main);
        appendInitParams.userParams = {
            UserID: res.userRes.id || null,
            Username: res.userRes.login || null,
            Org: mainOrg?.name || null,
        };
    }
    window.ym(config.metrikaId, 'init', { ...ymInitParams, ...appendInitParams });
}
